import axios from 'axios';

import { uploadImage, uploadsUrl } from '../services/uploadsClient';

export function copyUrlToClipboard(url) {
    const textArea = document.createElement('textarea');
    textArea.value = url;
    textArea.style.position = 'fixed';
    textArea.style.left = -1000;
    textArea.style.top = -1000;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand('copy');
    document.body.removeChild(textArea);
}

export function generateFragmentObject(url, colorMap) {
    const DEFAULT_COLOR = '#c4cdd6';
    const fragments = [];

    const queryIndex = url.indexOf('?') + 1;
    fragments.push({ value: url.substring(0, queryIndex), color: DEFAULT_COLOR });

    const queries = url.substring(queryIndex).split('&');
    queries.forEach((query) => {
        const split = query.split('=');
        const color = colorMap[split[0]] ? colorMap[split[0]] : DEFAULT_COLOR;
        fragments.push({ value: query, color });
        fragments.push({ value: '&', color: DEFAULT_COLOR });
    });
    fragments.pop();

    return {
        url,
        fragments,
    };
}

export function downloadImage(url) {
    return new Promise((resolve, reject) => {
        axios({ url })
            .then(() => {
                const imageObj = new Image();
                imageObj.onload = function onload() {
                    resolve(this);
                };
                imageObj.src = url;
            }).catch((response) => {
                reject(response.data);
            });
    });
}

export function addQueryStringData(url, queryStringData = {}) {
    const data = Object.keys(queryStringData)
        .filter(key => queryStringData[key] != null)
        .map(key => `${key}=${encodeURIComponent(queryStringData[key])}`);

    if (!data.length) {
        return url;
    }

    return `${url}${url.indexOf('?') > 0 ? '&' : '?'}${data.join('&')}`;
}

export function uploadImageAndGetUrl(file) {
    if (!file.type.match(/image\/(jpeg|png|bmp)/)) {
        return Promise.reject('Must choose an image to upload');
    }
    return uploadImage(file)
        .then(response => uploadsUrl(response.data[0].uploadId))
        .catch((error) => {
            console.error(`Failure to upload image: ${error.message}`);
            throw error;
        });
}

export function uploadImageAndGetSize(file) {
    return new Promise((resolve, reject) => {
        const fr = new FileReader();
        fr.onload = () => {
            if (fr.result.search(/data:image\/(jpeg|png|bmp)/) < 0) {
                reject('Must choose an image to upload');
            }
            const img = new Image();
            img.onload = () => {
                uploadImage(file)
                    .then((response) => {
                        const { uploadId } = response.data[0];
                        const url = uploadsUrl(uploadId);
                        resolve({ url, width: img.width, height: img.height });
                    })
                    .catch((e) => {
                        console.error(e);
                        reject('Uploads service failed to retrieve the image. Details can be found in the developer console and the network tab.');
                    });
            };

            img.src = fr.result;
        };

        fr.readAsDataURL(file);
    });
}

export function makeHttps(url) {
    if (url.match(/^https:/)) {
        return url;
    }
    return `${url.slice(0, 4)}s${url.slice(4)}`;
}



// WEBPACK FOOTER //
// ./src/util/url.js